import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SortDropdown = ({ onSort }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState('featured');
  const dropdownRef = useRef(null);

  const sortOptions = [
    { value: 'featured', label: 'Featured First', icon: 'Star' },
    { value: 'rating', label: 'Highest Rated', icon: 'TrendingUp' },
    { value: 'reviews', label: 'Most Reviewed', icon: 'MessageCircle' },
    { value: 'price-low', label: 'Price: Low to High', icon: 'ArrowUp' },
    { value: 'price-high', label: 'Price: High to Low', icon: 'ArrowDown' },
    { value: 'newest', label: 'Newest First', icon: 'Clock' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSortSelect = (sortValue) => {
    setSelectedSort(sortValue);
    setIsOpen(false);
    onSort?.(sortValue);
  };

  const selectedOption = sortOptions.find(option => option.value === selectedSort);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-white border border-border
                   rounded-lg hover:bg-background-light hover:border-border-focus transition-all
                   duration-200 shadow-elevation-1 min-w-[160px]"
      >
        <Icon name="ArrowUpDown" size={16} className="text-text-secondary" />
        <span className="text-sm font-medium text-text-primary">
          {selectedOption?.label}
        </span>
        <Icon
          name="ChevronDown"
          size={16}
          className={`text-text-secondary transition-transform duration-200 ml-auto ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 w-56 bg-white rounded-lg shadow-elevation-4
                         border border-border z-dropdown overflow-hidden">
          <div className="py-2">
            {sortOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => handleSortSelect(option.value)}
                className={`w-full flex items-center space-x-3 px-4 py-3 text-left
                           transition-colors duration-200 ${
                  selectedSort === option.value
                    ? 'bg-background-light text-primary' // Updated from blue-50 and blue-600
                    : 'text-text-secondary hover:text-text-primary hover:bg-background-light' // Updated from blue-50
                }`}
              >
                <Icon
                  name={option.icon}
                  size={16}
                  className={selectedSort === option.value ? 'text-primary' : 'text-text-secondary'} // Updated from blue-600
                />
                <span className="text-sm font-medium flex-1">{option.label}</span>
                {selectedSort === option.value && (
                  <Icon name="Check" size={14} className="text-primary" />
                )}
              </button>
            ))}
          </div>

          {/* Sort Info */}
          <div className="border-t border-border px-4 py-3 bg-background-light"> {/* Updated from gray-50 */}
            <div className="text-xs text-text-secondary">
              <div className="flex items-center space-x-1 mb-1">
                <Icon name="Info" size={12} />
                <span>Sorting by: {selectedOption?.label}</span>
              </div>
              <p>Results are automatically updated based on your selection</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
